<dx-box height="100%" width="100%" direction="col">
    <dxi-item *ngIf="!isPopupMode && hideTitle" baseSize="auto">
        <div *dxTemplate>
            <h2 class="page-header" [ngClass]="{ 'cc-text-center': isSmallScreen }">
                AAP Workflow
                <sup class="page-help-link">
                    <a [href]="helpLink" target="_blank" class="fas fa-question-circle"></a>
                </sup>
            </h2>
        </div>
    </dxi-item>
    <dxi-item [ratio]="1" class="cc-white-background">
        <div *dxTemplate>
            <div class="splitter-container">
                <as-split
                    class="as-split"
                    direction="horizontal"
                    unit="percent"
                    gutterSize="5"
                    [useTransition]="true"
                    (dragStart)="onSplitterDragStart()"
                    (dragEnd)="onSplitterDragEnd($event)"
                >
                    <as-split-area
                        class="as-split-area"
                        [size]="pdfViewerWidth"
                        [order]="pdfOrder"
                        [visible]="!separateWindow"
                    >
                        <app-workflow-invoice-viewer
                            #workflowInvoiceViewer
                            [source]="pdfURL"
                            [loader]="pdfLoader"
                        ></app-workflow-invoice-viewer>
                    </as-split-area>
                    <as-split-area [size]="formPanelWidth" [order]="invoiceOrder">
                        <!-- Scanned and Aapverify -->
                        <app-workflow-data-entry
                            #workflowDataEntry
                            *ngIf="isDataEntryStep()"
                            [workflowId]="workflowId"
                            [communityId]="communityId"
                            [isPopupMode]="isPopupMode"
                            (pdfURL)="onPdfURL($event)"
                            (pdfLoader)="onPdfLoader($event)"
                            (closeParentContainer)="onEditorClose($event)"
                            (splitterPositionChange)="onSplitterPositionChange($event)"
                            (hideSplitter)="onHideSplitter($event)"
                        ></app-workflow-data-entry>
                        <!-- AapSupervisor-->
                        <app-workflow-supervisor
                            *ngIf="isSupervisorStep()"
                            [workflowId]="workflowId"
                            [communityId]="communityId"
                            [isPopupMode]="isPopupMode"
                            (closeSupervisorEditor)="onEditorClose($event)"
                            (splitterPositionChange)="onSplitterPositionChange($event)"
                            (hideSplitter)="onHideSplitter($event)"
                            (pdfURL)="onPdfURL($event)"
                            (pdfLoader)="onPdfLoader($event)"
                        ></app-workflow-supervisor>

                        <!-- CAMInbox-->
                        <app-workflow-cam-editor
                            *ngIf="isCAMInbox()"
                            [workflowId]="workflowId"
                            [communityId]="communityId"
                            [isPopupMode]="isPopupMode"
                            (closeEditor)="onEditorClose($event)"
                            (splitterPositionChange)="onSplitterPositionChange($event)"
                            (hideSplitter)="onHideSplitter($event)"
                            (pdfURL)="onPdfURL($event)"
                            (pdfLoader)="onPdfLoader($event)"
                        ></app-workflow-cam-editor>

                        <!-- AccountantStepEditor-->
                        <app-workflow-accountant-editor
                            *ngIf="isAccountantStep()"
                            [workflowId]="workflowId"
                            [communityId]="communityId"
                            [isPopupMode]="isPopupMode"
                            (closeEditor)="onEditorClose($event)"
                            (splitterPositionChange)="onSplitterPositionChange($event)"
                            (hideSplitter)="onHideSplitter($event)"
                            (pdfURL)="onPdfURL($event)"
                            (pdfLoader)="onPdfLoader($event)"
                        ></app-workflow-accountant-editor>

                        <!-- Denied Step Editor-->
                        <app-workflow-denied-editor
                            *ngIf="isDeniedStep()"
                            [workflowId]="workflowId"
                            [communityId]="communityId"
                            [isPopupMode]="isPopupMode"
                            (closeDeniedEditor)="onEditorClose($event)"
                            (splitterPositionChange)="onSplitterPositionChange($event)"
                            (hideSplitter)="onHideSplitter($event)"
                            (pdfURL)="onPdfURL($event)"
                            (pdfLoader)="onPdfLoader($event)"
                        ></app-workflow-denied-editor>

                        <!-- ApprovedStepEditor-->
                        <app-workflow-approved-step
                            *ngIf="isApprovedStep()"
                            [workflowId]="workflowId"
                            [communityId]="communityId"
                            [isPopupMode]="isPopupMode"
                            (closeEditor)="onEditorClose($event)"
                            (splitterPositionChange)="onSplitterPositionChange($event)"
                            (hideSplitter)="onHideSplitter($event)"
                            (pdfURL)="onPdfURL($event)"
                            (pdfLoader)="onPdfLoader($event)"
                        ></app-workflow-approved-step>
                    </as-split-area>
                </as-split>
            </div>
        </div>
    </dxi-item>
</dx-box>
